import React, { useRef } from "react"
import { HiOutlineCheck } from "react-icons/hi2"
import { motion, useScroll, useTransform } from "framer-motion"

const SecondSection = ({ isHaveContent, isSubContent, title, content, subContent }) => {
  return (
    <div className="pt-8">
      {/* Heading */}
      <h3 className="font-roboto font-bold text-darkGray text-2xl leading-[1]">{title}</h3>
      {/* Content */}
      {isHaveContent && <p className="font-arial text-base text-darkGray pt-8">{content}</p>}
      {/* Sub title */}
      {isSubContent && <p className="font-arial text-base text-darkGray pt-8">{subContent}</p>}
    </div>
  )
}

const List = ({ list }) => {
  return (
    <div>
      {list.map((listItem, index) => (
        <div key={`listItem-${index}`}>
          {/* list title */}
          <p className="font-arial text-base text-darkGray pt-8">{listItem.listTitle}</p>
          {/* list items */}
          {listItem.listItems.map((item, i) => (
            <p
              key={`listItem-${index}-${i}`}
              className="font-arial text-base text-darkGray pt-1.5 flex items-center gap-2"
            >
              <span>
                <HiOutlineCheck color="#31435B" />
              </span>
              <span>{item}</span>
            </p>
          ))}
          {listItem.listItemSubContent && (
            <p className="font-arial text-base text-darkGray pt-8">{listItem.listItemSubContent}</p>
          )}
        </div>
      ))}
    </div>
  )
}

const SolutionItem = ({ isImgLeft = false, tabDataItem, isAboveLargeScreen, index }) => {
  const {
    content,
    image,
    isDoubleSection,
    isHaveContent,
    isHaveList,
    isSubContent,
    title,
    subContent,
    secondSection,
    list,
    category,
    subTitle,
  } = tabDataItem

  const ref = useRef(null)

  return (
    <motion.div ref={ref}>
      <div
        className={`flex flex-col lg:flex-row my-20   gap-6 ${
          category === "accounting" && index < 2 ? "items-start" : "items-center"
        }`}
      >
        <div className={`flex-1 ${isImgLeft ? "order-2" : "order-1"}`}>
          {/* Heading */}
          <h3 className="font-roboto font-bold text-darkGray text-2xl leading-[1]">{title}</h3>

          {/* subTitle */}
          {subTitle && <p className="font-arial text-base text-darkGray pt-8">{subTitle}</p>}

          {/* Content */}
          {isHaveContent && content && <p className="font-arial text-base text-darkGray pt-8">{content}</p>}

          {/* Sub content */}
          {isSubContent && subContent && <p className="font-arial text-base text-darkGray pt-8">{subContent}</p>}

          {/* if have secondSection */}
          {isDoubleSection && (
            <SecondSection isHaveContent={isHaveContent} isSubContent={isSubContent} {...secondSection} />
          )}

          {/* if have list */}
          {isHaveList && <List list={list} />}
        </div>

        {/* image */}
        <div className={` flex-1  ${isImgLeft ? "order-1" : "order-2"}`}>
          <img className="w-full h-auto object-cover rounded " src={image} alt="portfolio" />
        </div>
      </div>
    </motion.div>
  )
}

export default SolutionItem
